import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

const returnSteps = [
  {
    title: "Retoure vorbereiten",
    text: "Artikel ungetragen, sauber und mit vorhandenen Etiketten in die Versandverpackung legen.",
  },
  {
    title: "Paket kennzeichnen",
    text: "Bestellnummer auf dem Rücksendeschein ergänzen und das bereitgestellte Retourenetikett gut sichtbar aufkleben.",
  },
  {
    title: "Abgeben & verfolgen",
    text: "Paket beim angegebenen Versandpartner abgeben und den Einlieferungsbeleg bis zur Erstattung aufbewahren.",
  },
];

function Returns() {
  const { brandName, contact = {} } = siteConfig;
  const { email } = contact;

  return (
    <main className="returns">
      <header className="returns__hero">
        <div className="returns__hero-copy">
          <nav className="returns__breadcrumb" aria-label="Brotkrümelnavigation">
            <Link to="/">Startseite</Link>
            <span aria-hidden="true">/</span>
            <span aria-current="page">Retoure</span>
          </nav>
          <p className="returns__eyebrow">Einfach zurückgeben</p>
          <h1>Manchmal passt es einfach nicht.</h1>
          <p>
            Du kannst geeignete Artikel innerhalb von 30 Tagen in Ruhe
            zurücksenden. Wir führen dich Schritt für Schritt durch die Retoure.
          </p>
        </div>
        <div className="returns__hero-art" aria-hidden="true">
          <span>30</span>
          <small>Tage Rückgabefrist</small>
        </div>
      </header>

      <section className="returns__steps" aria-labelledby="return-steps-title">
        <div className="returns__section-heading">
          <p className="returns__eyebrow">So funktioniert es</p>
          <h2 id="return-steps-title">In drei Schritten zurück zu uns</h2>
        </div>
        <ol>
          {returnSteps.map((step, index) => (
            <li key={step.title}>
              <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </li>
          ))}
        </ol>
      </section>

      <section className="returns__conditions" aria-labelledby="conditions-title">
        <div className="returns__conditions-copy">
          <p className="returns__eyebrow">Gut zu wissen</p>
          <h2 id="conditions-title">Damit alles reibungslos läuft</h2>
          <p>
            Bitte behandle Artikel während der Anprobe so, wie du es auch in
            einem Geschäft tun würdest. Das hilft uns, einwandfreie Ware wieder
            in den Kreislauf zu bringen und Ressourcen zu schonen.
          </p>
        </div>

        <div className="returns__table-wrap" tabIndex="0">
          <table>
            <caption className="returns__visually-hidden">
              Bedingungen für Rücksendungen
            </caption>
            <thead>
              <tr>
                <th scope="col">Artikelzustand</th>
                <th scope="col">Hinweis</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Bekleidung</th>
                <td>Ungetragen, ungewaschen und möglichst mit Originaletikett.</td>
              </tr>
              <tr>
                <th scope="row">Wäsche &amp; Bademode</th>
                <td>Nur mit intaktem Hygieneschutz und über eigener Wäsche anprobiert.</td>
              </tr>
              <tr>
                <th scope="row">Sets</th>
                <td>Vollständig mit allen zusammengehörigen Teilen zurücksenden.</td>
              </tr>
              <tr>
                <th scope="row">Personalisierte Ware</th>
                <td>Eine Rückgabe kann ausgeschlossen sein, sofern kein Mangel vorliegt.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="returns__refund" aria-labelledby="refund-title">
        <div className="returns__refund-art" aria-hidden="true">
          <span>↙</span>
        </div>
        <div className="returns__refund-copy">
          <p className="returns__eyebrow">Erstattung</p>
          <h2 id="refund-title">Zurück auf demselben Weg</h2>
          <p>
            Sobald deine Rücksendung bei uns eingetroffen und geprüft ist,
            erstatten wir den entsprechenden Betrag über die ursprünglich
            verwendete Zahlungsart. Je nach Zahlungsanbieter kann es einige
            Werktage dauern, bis die Gutschrift sichtbar ist.
          </p>
          <ul>
            <li>Du erhältst eine Bestätigung, sobald die Retoure bearbeitet wurde.</li>
            <li>Bei Teilretouren werden nur die zurückgesendeten Artikel erstattet.</li>
            <li>Gesetzliche Gewährleistungsrechte bleiben unberührt.</li>
          </ul>
        </div>
      </section>

      <section className="returns__help" aria-labelledby="return-help-title">
        <div>
          <p className="returns__eyebrow">Wir schauen gemeinsam hin</p>
          <h2 id="return-help-title">Kein Retourenetikett oder ein fehlerhafter Artikel?</h2>
          <p>
            Nenne uns am besten deine Bestellnummer und eine kurze Beschreibung.
            Das Serviceteam von {brandName} hilft dir schnell weiter.
          </p>
          {email && <a href={`mailto:${email}`}>{email}</a>}
        </div>
        <Link className="returns__button" to="/contact">
          Service kontaktieren
        </Link>
      </section>
    </main>
  );
}

export default Returns;
